export class NavMenuItem {
  /*
    constructor(
        public title:string, 
        public path:string, 
        public icon:string,
        public displayOrder:number = 0,
        public external:boolean = false,
    ) {}
*/
  constructor(navItem: Partial<NavMenuItem>) {
    if (navItem.id == null)
      throw new Error(
        `Invalid navItem in constructor: ${JSON.stringify(navItem)} id cannot be null`,
      );
    if (navItem.title == null)
      throw new Error(
        `Invalid navItem in constructor: ${JSON.stringify(navItem)} title cannot be null`,
      );
    if (navItem.path == null)
      throw new Error(
        `Invalid navItem in constructor: ${JSON.stringify(navItem)} path cannot be null`,
      );

    if (navItem.icon == null) {
      navItem.icon = 'arrow_right_alt';
    }
    if (navItem.displayOrder == null) {
      navItem.displayOrder = 0;
    }
    if (navItem.external == null) {
      navItem.external = false;
    }

    this.id = navItem.id;
    this.title = navItem.title;
    this.path = navItem.path;
    this.icon = navItem.icon;
    this.displayOrder = navItem.displayOrder;
    this.external = navItem.external;
    this.menu = navItem.menu || '';
    if (this.menu == null) {
      this.menu = '';
    }
  }

  public static createEmpty() {
    return new NavMenuItem({ id: '', title: '', path: '', icon: '', menu: '' });
  }

  id: string;
  title: string;
  path: string;
  icon: string;
  displayOrder: number;
  external: boolean;
  menu: string;
}
